import { useNavigate } from "react-router";
import ComponentCard from "../../../components/common/ComponentCard";
import PageMeta from "../../../components/common/PageMeta";
import Button from "../../../components/ui/button/Button";
import VenueAreasTable from "./VenueAreasTable";


const VenueAreas = () => {
  const navigate = useNavigate();

  return(
    <>
      <PageMeta 
        title="Venue Areas | Hospitality Genie"
        description="Compliance Inspections - Venue Areas"
      />
      <div className="space-y-6">
      <ComponentCard title="Venue Areas">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">Venue Areas</div>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <Button
              className="inline-flex items-center gap-2 px-4 py-3 text-sm font-medium rounded-lg bg-[#142900] hover:bg-[#3d5e42]" size="sm" 
              onClick={() => navigate('/add-new-venue-area')}
            >
              Add New Venue Areas
            </Button>
            </div>
        </div>
        
        <div>
          {/* Table Component */}
            <VenueAreasTable />
            
        </div>
      </ComponentCard>
      </div>
    </>
  );

}

export default VenueAreas;